import { Button, Tag, Typography } from "antd";
import { useEffect, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  GET_DIGITALIZATION_APP_USERS,
  MACHINE_MAINTENANCE_MECHANICS,
} from "../../../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../../../apiServices/common";
import AppContent from "../../../../../common/AppContent";
import HandleNotification from "../../../../../common/Notification";
import AppPageHeader from "../../../../../common/PageHeader";
import { onDeleteUser, onGetUserDetails } from "../../../../../redux/actions";
import { USER_CREATE_PERMISSION } from "../../../../../routes/permissions";
import { hasPermission } from "../../../../../utils/functions";
import ExtraContent from "../../../../Configuration/CommonComponents/ExtraContent";
import FilterComponent from "../../../../Configuration/CommonComponents/FilterComponent";
import UserListTable from "./MechanicUserListTable";
import { useSelector } from "react-redux";

const MechanicUserList = (props) => {
  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;
  const navigate = useNavigate();

  // States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [page, setPage] = useState(1);
  const [refresh, setRefresh] = useState(0);
  const [userList, setUserList] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [filterValues, setFilterValues] = useState({});

  // Redux
  const dispatch = useDispatch();

  // Antd
  const { Title } = Typography;

  // Filter open/close status update in localStorage
  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  const filterData = useSelector(({ filter }) => filter.filterData);

  const getAllUsers = async (filterValues) => {
    const query = `${MACHINE_MAINTENANCE_MECHANICS}`;
    const bodyData = {
      page: page,
      per_page: filterValues?.per_page || 10,
      ...(filterValues?.name && { name: filterValues?.name }),
      ...(filterValues?.email && { email: filterValues?.email }),
      ...(filterValues?.id_card_no && { id_card_no: filterValues?.id_card_no }),
      // ...(filterValues?.role_id && { role_id: filterValues?.role_id }),
    };

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setUserList(response?.data?.data?.data);
      setPageSize(response?.data?.data?.per_page);
      setTotal(response?.data?.data?.total);
    } else {
      HandleNotification("error", "Error", "Something went wrong");
    }
  };

  useEffect(() => {
    getAllUsers({ ...filterData, per_page: pageSize, page: page });
  }, [refresh, filterData, page, pageSize]);

  const refetch = () => {
    setRefresh(refresh + 1);
  };

  const onPageChange = (newPage) => {
    setPage(newPage);
  };

  const handleDelete = (event, record) => {
    dispatch(onDeleteUser(record));
    refetch();
  };

  const handleEdit = (event, record) => {
    dispatch(onGetUserDetails(record.id));
    navigate("/settings/users/create-user", { state: record });
  };
  const filterName = "mechanic_users_list";
  const tableColumns = [
    { title: "Name", dataIndex: "name", key: "name", width: "15%" },
    { title: "Email", dataIndex: "email", key: "email", align: "center" },
    {
      title: "Id Card No",
      dataIndex: "id_card_no",
      key: "id_card_no",
      align: "center",
    },
    { title: "Role", dataIndex: "role", key: "role", align: "center" },
    { title: "Lines", dataIndex: "line_name", key: "line_name" },
    {
      title: "Maintenance Status",
      dataIndex: "maintenance_status_label",
      key: "maintenance_status_label",
      align: "center",
      render: (text, record) => {
        const statusColor =
          record.maintenance_status_label === "Free" ? "green" : "red";
        return <Tag color={statusColor}>{text}</Tag>;
      },
    },
    {
      title: "Attendance Status",
      dataIndex: "attendance_status_label",
      key: "attendance_status_label",
      align: "center",
      render: (text, record) => {
        const statusColor =
          record.attendance_status_label === "Present"
            ? "green"
            : record.attendance_status_label === "Absent"
            ? "red"
            : "blue";
        return <Tag color={statusColor}>{text ?? "N/A"}</Tag>;
      },
    },
    {
      title: "Attendance Initiated By",
      dataIndex: "attendance_initiated_by",
      key: "attendance_initiated_by",
      align: "center",
      render: (text, record) => {
        return text ? text : "N/A";
      },
    },
    {
      title: "Attendance Updated By",
      dataIndex: "attendance_updated_by",
      key: "attendance_updated_by",
      align: "center",
      render: (text, record) => {
        return text ? text : "N/A";
      },
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   width: "15%",
    //   render: (_, record) => (
    //     <div>
    //       <Popconfirm
    //         title="Are you sure you want to delete?"
    //         onConfirm={(event) => handleDelete(event, record)}
    //       >
    //         <Button
    //           size="small"
    //           danger
    //           style={{ marginLeft: 5 }}
    //           disabled={!hasPermission([USER_DELETE_PERMISSION])}
    //         >
    //           Delete
    //         </Button>
    //       </Popconfirm>

    //       <Button
    //         style={{ marginLeft: 5 }}
    //         size="small"
    //         onClick={(event) => {
    //           handleEdit(event, record);
    //         }}
    //         disabled={!hasPermission([USER_EDIT_PERMISSION])}
    //       >
    //         Edit
    //       </Button>
    //     </div>
    //   ),
    // },
  ];

  const handleNav = (event, record) => {
    navigate("/settings/users/create-user", {
      state: props.selectedUserDetails,
    });
  };

  const handleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const onFilterChange = (values) => {
    setFilterValues(values);
  };

  const memoizedCustomFilter = useMemo(
    () => (
      <FilterComponent
        tableData={userList}
        filterAPI={onFilterChange}
        filterName={"mechanic_users_list"}
        setShowFilter={setShowFilter}
        showFilter={showFilter}
      />
    ),
    [showFilter, userList],
  );

  const header = (
    <AppPageHeader
      title={<Title level={5}>Machine Maintenance Mechanics</Title>}
      extra={
        <ExtraContent
          refresh={refresh}
          setRefresh={refetch}
          setShowFilter={setShowFilter}
          showFilter={showFilter}
          hideAddButton={true}
          handleAddItemOpen={handleNav}
        />
      }
    />
  );

  const content = (
    <>
      {memoizedCustomFilter}
      <UserListTable
        onChange={(newPage) => {
          onPageChange(newPage);
        }}
        total={total}
        current={page}
        defaultCurrent={page}
        pageSize={pageSize}
        dataSource={userList}
        tableColumns={tableColumns}
        pagination={true}
      />
    </>
  );
  return (
    <>
      <AppContent header={header} content={content} />
    </>
  );
};

export default MechanicUserList;
